import { combineReducers } from "redux";
import week from "../features/admin/masters/week/Slice";
import country from "../features/admin/masters/country/Slice";
import state from "../features/admin/masters/state/Slice";
import city from "../features/admin/masters/city/Slice";
import district from "../features/admin/masters/district/Slice";
import pincode from "../features/admin/masters/pincode/Slice";
import gender from "../features/admin/masters/gender/Slice";
import occupation from "../features/admin/masters/occupation/Slice";
import faq from "../features/admin/masters/faq/Slice";

const masters = combineReducers({
  week: week,
  country: country,
  state: state,
  city: city,
  district: district,
  pincode: pincode,
  gender: gender,
  occupation: occupation,
  faq: faq,
});

export default masters;
